module.exports = __webpack_public_path__ + "static/FryingFat-701bfdf5b654b0d148c56cb354b09c35.webp";